<template>
  <h-dialog v-model="visible" width="550px" title="文件预览" @onCancel="visible = false" :footer="false">
    <upload-file-multiple :isDetailShow="true" v-model="fileArr"></upload-file-multiple>
  </h-dialog>
</template>

<script setup>
import { ref } from "vue";
import { ElMessage } from "element-plus";

const visible = ref(false)
const fileArr = ref({})

function toggleVisible(arr = []) {
  fileArr.value = arr
  visible.value = true;
}

defineExpose({
  toggleVisible
})
</script>
